import React from 'react';
import PropTypes from 'prop-types';
import { Container, List } from '@pella/sash-framework';
import { CTA, Image, Video } from '../..';
import { setBackgroundColor } from '../../utilities/functions';
import styles from './index.module.scss';

const Feature = ({ data, className, ...other }) => {
	if (!data?.feature?.[0]) return null;

	return (
		<div
			id={data.anchor_text || null}
			className={`${styles.featureContainer} ${data.background_color ? styles[setBackgroundColor(data.background_color)] : ''} ${className || ''}`}
			{...other}
		>
			{data.heading && (
				<Container>
					<h2 className={styles.featureContainer_Heading}>{data.heading}</h2>
				</Container>
			)}

			{data.feature.map((item, index) =>
				item.style === 'text overlay' ? (
					<Container
						className='md:mb-8 md:flex md:flex-row-reverse md:items-center xl:mb-16'
						key={index}
					>
						{item.image?.[0] && !item.image[0].video?.video_id && (
							<div className='grid h-fit overflow-hidden'>
								{item?.highlighted_text?.heading && (
									<div
										className='text-h1 z-2 col-start-1 row-start-1 mb-0.5 self-end leading-[44px] md:leading-[56px] xl:mb-2 xl:leading-[80px] [&>p]:inline [&>p]:bg-primary [&>p]:box-decoration-clone [&>p]:px-1 md:[&>p]:px-4 [&_sup]:-top-[.7em] [&_sup]:text-[50%]'
										dangerouslySetInnerHTML={{
											__html: item.highlighted_text.heading,
										}}
									/>
								)}
								<Image
									className='col-start-1 row-start-1'
									objectFit='contain'
									data={item.image[0]}
								/>
							</div>
						)}
						<div className='pb-8 pt-6 md:mr-4 md:max-w-[36%] md:py-0 xl:max-w-[32.7%]'>
							{item?.label_heading && (
								<div className='mb-2.5'>
									<p className='text-overline w-fit bg-black px-[14px] py-1 text-white'>{item.label_heading}</p>
								</div>
							)}
							{item.heading && (
								<h2
									dangerouslySetInnerHTML={{
										__html: item.heading,
									}}
								/>
							)}
							{item.description && (
								<div
									className='mb-2.5'
									dangerouslySetInnerHTML={{
										__html: item.description,
									}}
								/>
							)}

							{item.ctas?.[0] && (
								<CTA
									data={item.ctas?.[0]}
									key={index}
								/>
							)}
						</div>
					</Container>
				) : (
					<div
						key={index}
						className={`${item.style ? styles[`feature_${item.style.replace(/-/g, '')}`] : ''}`}
					>
						<Container className='my-6 md:my-8 xl:my-12'>
							<div className={`${styles.featureWrapper} ${item.image_position === 'right' ? styles.featureWrapper_imageRight : ''}`}>
								{item.image?.[0] && !item.image[0].video?.video_id && (
									<div className={styles.feature_ImageCol}>
										<Image
											data={item.image[0]}
											className={`${styles.feature_Image} !block`}
										/>
									</div>
								)}
								{item.image?.[0]?.video?.video_id && (
									<div className={styles.feature_ImageCol}>
										<Video
											data={item.image[0]}
											className={`${styles.feature_Video} !h-auto`}
										/>
									</div>
								)}
								<div className={styles.feature_Content}>
									{item.label_heading && <p className='text-overline mb-1.5 text-gray-60'>{item.label_heading}</p>}

									{item.heading && (
										<h2
											className={styles.feature_Heading}
											dangerouslySetInnerHTML={{
												__html: item.heading,
											}}
										/>
									)}
									{item.description && (
										<div
											dangerouslySetInnerHTML={{
												__html: item.description,
											}}
											className={styles.feature_Description}
										/>
									)}
									{item.ctas?.[0] && (
										<List
											bullets='none'
											layout='inline'
											className={styles.feature_CtaList}
										>
											{item.ctas.map((link, index) => (
												<li key={index}>
													<CTA
														data={link}
														className={styles.feature_CTA}
														key={index}
													/>
												</li>
											))}
										</List>
									)}
								</div>
							</div>
						</Container>
					</div>
				)
			)}
		</div>
	);
};

Feature.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default Feature;
